import { api } from "./api";

export interface CitizenshipBatchResult {
  batch_id: string;
  updated_ids: string[];
  skipped: { worker_id: string; worker_name: string; reason: string }[];
  undo_expires_at: string;
}

export async function fillCitizenship(workerIds: string[], countryIso2: string) {
  return (await api.post<CitizenshipBatchResult>("/radnici/citizenship-batches", { worker_ids: workerIds, country_iso2: countryIso2 })).data;
}

export async function undoCitizenship(batchId: string) {
  return (await api.post<CitizenshipBatchResult>(`/radnici/citizenship-batches/${batchId}/undo`)).data;
}
